import React, { Component } from "react";

import { CButton, CCard, CCol, CLink, CPagination, CRow } from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { setObj } from "../../../actions/noteActions";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import { formatDate, baseDate } from "../../../utils/date";
import LiterarteModal from "../../LiterarteModal";
import LiterartePersonalCreateModal from "../../LiterartePersonalCreateModal";
import Loading from "../../Loading";

class LiterarteActivities extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      activities: [],
      textProduction: {
        id: "",
        show: false,
        value: [
          {
            type: "paragraph",
            children: [{ text: "" }]
          }
        ]
      },
      create: false,
      // activity_id: null,
      // id: null,
      // user_id: null,
      // allocation_id: null,
      // item_id: null,
      // execution_id: null,
      // correctLiterarteModal: false,
      late: false,
      maxItems: 12,
      currentPage: 1
    };
  }

  componentDidMount() {
    this.handleActivities();
  }

  handleActivities(showLoading = true) {
    if (showLoading) {
      this.setState({ loading: true });
    }

    axios
      .get(`${URL.api}literarte/activity/personal`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.setState({ loading: false, activities: resp.data.data });
          } else {
            toastr.error(
              "Falha",
              "Não foi possível obter as atividades do Literarte"
            );
            this.setState({ loading: false });
          }
        },
        err => {
          toastr.error(
            "Falha",
            "Não foi possível obter as atividades do Literarte"
          );
          this.setState({ loading: false });
        }
      );
  }

  saveTextProduction = pages => {
    let pagesObj = [];
    for (let i = 0; i < pages.length; i++) {
      pagesObj.push({
        number: i,
        content: JSON.stringify(pages[i])
      });
    }

    let obj = {
      user_id: this.props.user.user.id,
      literarte_activity_id: this.state.textProduction.id,
      pages: pagesObj,
      item_id: null,
      execution_id: null,
      start: baseDate(this.state.literarteStart),
      end: baseDate(new Date())
    };

    axios
      .post(`${URL.api}literarte/production_create`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            toastr.success("Sucesso", "O texto foi salvo.");
            this.setState(
              state => ({
                textProduction: {
                  ...state.textProduction,
                  show: false
                }
              }),
              () => this.handleActivities(false)
            );
          } else {
            toastr.error("Falha", "Não foi possível salvar o texto.");
          }
        },
        error => {
          toastr.error("Falha", "Não foi possível salvar o texto.");
        }
      );
  };

  openActivity(e, activity) {
    e.preventDefault();

    this.setState(state => ({
      textProduction: {
        ...state.textProduction,
        show: true,
        id: activity.id
      },
      // execution_id: null,
      // item_id: null,
      contentName: activity.title,
      literarteStart: new Date(),
      late: false
    }));
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="w-100 d-flex p-4 justify-content-center align-items-center">
          <Loading />
        </div>
      );
    }

    const searchedActivities = this.state.activities.filter(
      activity =>
        !this.props.search ||
        activity.title.toLowerCase().includes(this.props.search.toLowerCase())
    );

    if (searchedActivities.length === 0) {
      return (
        <>
          <div className="d-flex justify-content-end mb-3">
            <CButton
              color="primary"
              onClick={() => this.setState({ create: true })}
            >
              <i className="fa fa-plus mr-2"></i>Nova
            </CButton>
          </div>
          <div className="w-100 d-flex p-4 justify-content-center align-items-center text-muted">
            Nenhuma produção encontrada
          </div>
          {this.state.create && (
            <LiterartePersonalCreateModal
              onClose={() =>
                this.setState({ create: false }, () =>
                  this.handleActivities(false)
                )
              }
            />
          )}
        </>
      );
    }

    return (
      <>
        <div className="d-flex justify-content-end mb-3">
          <CButton
            color="primary"
            onClick={() => this.setState({ create: true })}
          >
            <i className="fa fa-plus mr-2"></i>Nova
          </CButton>
        </div>
        <CRow>
          {searchedActivities
            .slice(
              (this.state.currentPage - 1) * this.state.maxItems,
              this.state.currentPage * this.state.maxItems
            )
            .map(activity => (
              <CCol xs="12" sm="6" md="4" xl="3" key={activity.id}>
                <CCard style={{ borderBottom: "3px solid var(--purple)" }}>
                  <div className="card-body">
                    <h5 className="card-title font-weight-semibold mb-0 text-ellipsis">
                      <CLink
                        to="#"
                        className="text-black"
                        onClick={e => this.openActivity(e, activity)}
                      >
                        {activity.title}
                      </CLink>
                    </h5>
                    <p className="card-text mb-3 text-ellipsis">
                      <small className="text-muted">Produção livre</small>
                    </p>
                    <p className="card-text mb-0 text-ellipsis">
                      {activity.type_name}
                    </p>
                    <div className="d-flex my-2">
                      <div
                        className="ml-3 mr-2 bg-light"
                        style={{ width: "1px" }}
                      ></div>
                      <div className="flex-1 text-muted small">
                        <div>Criado em {formatDate(activity.updated_at)}</div>
                      </div>
                    </div>
                    <p className="card-text mb-0 mt-3">
                      <small className="text-primary">
                        <i className="fa fa-user-circle mr-1"></i>Criado por mim
                      </small>
                    </p>
                  </div>
                </CCard>
              </CCol>
            ))}
        </CRow>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
          className="mb-3"
        >
          <div>
            <span>Total de atividades: {searchedActivities?.length || 0}</span>
          </div>
          <CPagination
            className="m-0"
            addListClass="m-0"
            activePage={this.state.currentPage}
            pages={
              Math.ceil(searchedActivities.length / this.state.maxItems) || 1
            }
            onActivePageChange={page => this.setState({ currentPage: page })}
            color="secondary"
          />
        </div>
        {this.state.create && (
          <LiterartePersonalCreateModal
            onClose={() =>
              this.setState({ create: false }, () =>
                this.handleActivities(false)
              )
            }
          />
        )}
        {this.state.textProduction.show ? (
          <LiterarteModal
            id={this.state.textProduction.id}
            user_id={this.props.user.user.id}
            show={this.state.textProduction.show}
            onClose={() =>
              this.setState(
                state => ({
                  textProduction: {
                    ...state.textProduction,
                    show: false
                  }
                }),
                () => this.handleActivities(false)
              )
            }
            title={this.state.contentName}
            value={this.state.textProduction.value}
            onChange={value =>
              this.setState(state => ({
                textProduction: {
                  // eslint-disable-next-line react/no-access-state-in-setstate
                  ...this.state.textProduction,
                  value
                }
              }))
            }
            saveTextProduction={pages => this.saveTextProduction(pages)}
            late={this.state.late}
          />
        ) : null}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiterarteActivities);
